import {
  default as MuiOutlinedInput,
  type OutlinedInputProps as MuiOutlinedInputProps,
  outlinedInputClasses as muiOutlinedInputClasses,
} from '@mui/material/OutlinedInput';

/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const OutlinedInput = MuiOutlinedInput;
/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export type OutlinedInputProps = MuiOutlinedInputProps;
/**
 * @deprecated Unsupported component: Use Input instead.
 * Please reach out to us in #unify-design-system-support if you have a use case for this component.
 */
export const outlinedInputClasses = muiOutlinedInputClasses;
